import JraEncodeDecodeModule from './JraEncodeDecodeModule';

export default class JraCampingUnit extends JraEncodeDecodeModule {
  constructor(element, encodeDecodeKey) {
    super(encodeDecodeKey);
    this.initJraCampingUnit(element);
  }


  initJraCampingUnit(element) {
    const hiddenCampingUnitInput = element.querySelector('[data-form-validation-camping-unit-hidden-input]');
    const lengthInput = element.querySelector('[data-form-validation-length-input]');
    const widthInput = element.querySelector('[data-form-validation-width-input]');
    const unitSelect = element.querySelector('[data-form-validation-unit-select]');

    lengthInput.addEventListener('input', this.onCampingUnitChange(hiddenCampingUnitInput));
    widthInput.addEventListener('input', this.onCampingUnitChange(hiddenCampingUnitInput));
    unitSelect.addEventListener('change', this.onCampingUnitChange(hiddenCampingUnitInput));
  }


  onCampingUnitChange = hiddenCampingUnitInput => () => {
    const event = document.createEvent('Event');
    event.initEvent('change', true, true);
    hiddenCampingUnitInput.dispatchEvent(event);
  }
}
